export default __webpack_public_path__ + "static/media/referralIcon.ef38f3dd.svg";